import React, { useState, useEffect } from 'react';
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const CORES_PREDEFINIDAS = [
    { nome: 'Cinza', cor: '#6c757d' },
    { nome: 'Azul', cor: '#0d6efd' },
    { nome: 'Verde', cor: '#198754' },
    { nome: 'Vermelho', cor: '#dc3545' },
    { nome: 'Amarelo', cor: '#ffc107' },
    { nome: 'Laranja', cor: '#fd7e14' },
    { nome: 'Roxo', cor: '#6f42c1' },
    { nome: 'Rosa', cor: '#d63384' },
    { nome: 'Ciano', cor: '#0dcaf0' },
    { nome: 'Verde-água', cor: '#20c997' },
    { nome: 'Azul Escuro', cor: '#0a58ca' },
    { nome: 'Verde Escuro', cor: '#146c43' },
    { nome: 'Marrom', cor: '#8b4513' },
    { nome: 'Índigo', cor: '#6610f2' },
    { nome: 'Coral', cor: '#ff6b6b' },
    { nome: 'Oliva', cor: '#808000' }
];

const TagModal = ({ tag, onClose, onTagAtualizada }) => {
    const [formData, setFormData] = useState({
        nome: '',
        cor: '#6c757d'
    });
    const [tituloModal, setTituloModal] = useState("");
    const [usarCorPersonalizada, setUsarCorPersonalizada] = useState(false);

    useEffect(() => {
        if (tag != null) {
            setFormData({
                nome: tag.nome || '',
                cor: tag.cor || '#6c757d'
            });
            setTituloModal('Editar Tag');

            const corPredefinida = CORES_PREDEFINIDAS.find(c => c.cor.toLowerCase() === tag.cor?.toLowerCase());
            setUsarCorPersonalizada(!corPredefinida);
        } else {
            setTituloModal('Nova Tag');
        }
    }, [tag]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCorChange = (cor) => {
        setFormData(prev => ({
            ...prev,
            cor: cor
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nome.trim()) {
            Swal.fire('Atenção', 'O nome da tag deve ser preenchido.', 'warning');
            return;
        }

        if (!formData.cor || !/^#[0-9A-Fa-f]{6}$/.test(formData.cor)) {
            Swal.fire('Atenção', 'Selecione uma cor válida.', 'warning');
            return;
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const dataToSend = { ...formData };

            if (tag) {
                await api.put(`/tags/${tag.id}`, dataToSend);
                Swal.fire("Sucesso", "Tag atualizada com sucesso!", "success");
            } else {
                await api.post('/tags', dataToSend);
                Swal.fire("Sucesso", "Tag criada com sucesso!", "success");
            }

            onTagAtualizada();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response?.data?.message || 'Erro ao salvar tag.', 'error');
        }
    };

    const getContrastColor = (hexColor) => {
        const hex = hexColor.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.5 ? '#000000' : '#ffffff';
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        maxLength={100}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Cor</label>
                                    <div className="d-flex flex-wrap gap-2 mb-3">
                                        {CORES_PREDEFINIDAS.map((corItem, index) => (
                                            <div
                                                key={index}
                                                onClick={() => {
                                                    handleCorChange(corItem.cor);
                                                    setUsarCorPersonalizada(false);
                                                }}
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    backgroundColor: corItem.cor,
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    border: formData.cor.toLowerCase() === corItem.cor.toLowerCase() && !usarCorPersonalizada
                                                        ? '3px solid #000'
                                                        : '1px solid #dee2e6',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transition: 'transform 0.2s'
                                                }}
                                                title={corItem.nome}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                            >
                                                {formData.cor.toLowerCase() === corItem.cor.toLowerCase() && !usarCorPersonalizada && (
                                                    <span style={{ color: getContrastColor(corItem.cor), fontWeight: 'bold' }}>✓</span>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="d-flex align-items-center gap-3 mt-3">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="corPersonalizada"
                                                checked={usarCorPersonalizada}
                                                onChange={(e) => setUsarCorPersonalizada(e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="corPersonalizada">
                                                Cor personalizada
                                            </label>
                                        </div>
                                        {usarCorPersonalizada && (
                                            <input
                                                type="color"
                                                value={formData.cor}
                                                onChange={(e) => handleCorChange(e.target.value)}
                                                style={{
                                                    width: '60px',
                                                    height: '40px',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer'
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Pré-visualização</label>
                                    <div className="p-3 bg-light rounded">
                                        <span
                                            className="badge px-3 py-2"
                                            style={{
                                                backgroundColor: formData.cor,
                                                color: getContrastColor(formData.cor),
                                                fontSize: '1rem'
                                            }}
                                        >
                                            {formData.nome || 'Nome da Tag'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TagModal;
